// extracted by mini-css-extract-plugin
export default {"tableRow":"tableRow__PDVdV","modal":"modal__FoEEF"};